import { jsx as o, jsxs as a } from "react/jsx-runtime";
import { forwardRef as O, useState as u, useRef as A, useEffect as E, useCallback as d } from "react";
import e from "./styles.module.less.js";
import _ from "./logo.svg.js";
import { Modal as w } from "../../general/modal/index.js";
import { MOBILE_WIDTH as D, TABLET_WIDTH as B } from "../../../utils/use-is-mobile.js";
import { CheckboxInput as L } from "../../general/checkbox-label/index.js";
const v = "terms-accepted", R = O((N, g) => {
  const {
    description: I,
    image: b,
    mobileImage: i,
    tabletImage: t,
    termsTitle: c,
    actionButton: r,
    bannerText: m,
    price: f,
    defaultOpen: k,
    closeIcon: y
  } = N, [l, p] = u(!1), T = A(null), [s, h] = u(!1);
  E(() => {
    l ? document.body.style.overflow = "hidden" : l === !1 && (document.body.style.overflow = "auto");
  }, [l]);
  const x = d(() => p(!0), []), M = d(() => p(!1), []), S = d(() => {
    s ? (localStorage.removeItem(v), h(!1)) : (localStorage.setItem(v, "true"), h(!0));
  }, [s]), C = /* @__PURE__ */ o(
    "button",
    {
      className: e.infoBodyContentActionButton,
      disabled: !s,
      onClick: r == null ? void 0 : r.onClick,
      children: r == null ? void 0 : r.text
    }
  );
  return /* @__PURE__ */ o(
    w,
    {
      ref: g,
      className: e.infoModal,
      defaultOpen: k ?? !1,
      isSimple: !0,
      onOpen: x,
      onClose: M,
      closeIcon: y,
      children: /* @__PURE__ */ a("div", { className: e.infoModalContent, ref: T, children: [
        /* @__PURE__ */ a("div", { className: e.headerCard, children: [
          /* @__PURE__ */ a("picture", { className: e.headerCardImageWrapper, children: [
            i && /* @__PURE__ */ o(
              "source",
              {
                srcSet: i,
                media: `(max-width: ${D}px)`
              }
            ),
            t && /* @__PURE__ */ o(
              "source",
              {
                srcSet: t,
                media: `(max-width: ${B}px)`
              }
            ),
            " ",
            /* @__PURE__ */ o(
              "img",
              {
                src: b,
                alt: "info-header-card",
                className: e.headerCardImage
              }
            )
          ] }),
          /* @__PURE__ */ o(_, { className: e.headerCardLogo }),
          m && /* @__PURE__ */ a("div", { className: e.bannerText, children: [
            m,
            f && /* @__PURE__ */ o("div", { className: e.price, children: f })
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: e.infoBodyContainer, children: /* @__PURE__ */ a("div", { className: e.infoBodyContent, children: [
          /* @__PURE__ */ o("div", { className: e.infoBodyContentDescription, children: I }),
          /* @__PURE__ */ a("div", { className: e.infoBodyContentTerms, children: [
            c && /* @__PURE__ */ o("div", { className: e.infoBodyContentTermsTitle, children: c }),
            /* @__PURE__ */ o("div", { className: e.termsClickable, children: /* @__PURE__ */ o(
              L,
              {
                label: /* @__PURE__ */ a("div", { className: e.termsClickableText, children: [
                  "I have read, understood, and agreed to our ",
                  /* @__PURE__ */ o(
                    "a",
                    {
                      href: "/en-us/terms",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: (n) => n.stopPropagation(),
                      children: "terms"
                    }
                  ),
                  " and ",
                  /* @__PURE__ */ o(
                    "a",
                    {
                      href: "/en-us/privacy",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: (n) => n.stopPropagation(),
                      children: "privacy policy"
                    }
                  ),
                  "."
                ] }),
                onChange: S,
                checked: s,
                className: e.termsCheckbox
              }
            ) })
          ] }),
          /* @__PURE__ */ o("div", { className: e.infoBodyContentAction, children: r != null && r.link ? /* @__PURE__ */ o("a", { href: r == null ? void 0 : r.link, children: C }) : C })
        ] }) })
      ] })
    }
  );
});
R.displayName = "InfoModal";
export {
  R as InfoModal
};
